import { useLang } from "hooks/useLang"
import dynamic from "next/dynamic"
import React from "react"
import EventMakingSectionCompanyMobile from "../EventMakingSectionDir/EventMakingSectionCompanyMobile"
import EventMakingSectionIndividualMobile from "../EventMakingSectionDir/EventMakingSectionIndividualMobile"
import { PassTicketsFeatures } from "../features"
import AboutUsHeroMobile from "./Hero"
import ServiceCardMobile from "./ServiceCardMobile"
import Form from "components/FormsPage/ContactUs/Form"
import ContactDetails from "components/FormsPage/ContactUs/ContactDetails"

const Footer = dynamic(() => import("components/Layout/Footer/Footer"), {
    ssr: false,
    loading: () => {
        return (
            <footer
                className={`fixed bottom-0 hidden h-[325px] flex-col overflow-hidden bg-white shadow-[0_0_9px_5px_rgba(0,0,0,0.05)] dark:bg-[#3A2B87] md:flex`}></footer>
        )
    },
})
const CreateYourEventComponentMobile = () => {
    const { t } = useLang()

    return (
        <div className="flex flex-col gap-4 bg-gradient-to-b from-[#221852] to-[#18113B]">
            <div className="w-full">
                <AboutUsHeroMobile />
            </div>

            <div className="layout">
                <div className="flex flex-col gap-2 lg:gap-4">
                    <span className="text-2xl font-normal text-white">
                        نخدمك بعيوننا
                    </span>

                    <div className="flex flex-col items-center justify-center gap-2">
                        {PassTicketsFeatures.map((feature) => (
                            <ServiceCardMobile
                                key={feature.service}
                                service={feature.service}
                                media={feature.media}
                                description={feature.description}
                            />
                        ))}
                    </div>
                    <div className="text-end text-2xl font-normal text-white">
                        ولسا ماخلصنا ..
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-center justify-center gap-12 py-12">
                <div className="text-center text-4xl font-bold text-white lg:text-8xl">
                    ليش باس تيكت؟
                </div>
                <div className="text-center text-3xl font-light text-white lg:text-7xl">
                    تنــوع .. خدمـات .. حلـول
                </div>
                <div className="text-center text-2xl font-light leading-10 text-white lg:text-4xl">
                    نسعى لتوفير أفضل فرص الفعاليات
                    <br />
                    والأنشطة لسكان المملكة وزوارها.
                </div>
            </div>

            <div className="flex flex-col items-center justify-center lg:hidden">
                <EventMakingSectionCompanyMobile />

                <EventMakingSectionIndividualMobile />
            </div>

            <div className="layout flex-1 py-10">
                <h1 className="mb-5 text-[56px] font-bold leading-[50px] md:mb-8 md:text-[100px] md:leading-[100px]">
                    {t("create_your_event")}
                </h1>

                <div className="flex flex-col items-start md:flex-row">
                    <Form />
                    <ContactDetails />
                </div>
            </div>

            <Footer />
        </div>
    )
}
export default CreateYourEventComponentMobile
